import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { GiftItemType } from '@models/gift';
import { PrepaidCardImage } from '@models/prepaidCard';
import { useFlow } from '@stackflow/react';
import { pressActionEffect } from '@styles/mixin';

interface Props {
    images: PrepaidCardImage[];
    type: 'GIFT' | 'BUY';
    giftItemId?: string;
}

function ImageGrid({ images, type, giftItemId }: Props) {
    const { push } = useFlow();

    const handleClick = (id: string) => {
        if (type === 'GIFT') {
            push('GiftOrderActivity', {
                giftItemId: giftItemId!,
                type: GiftItemType.CASH,
                qty: 1,
                giftCardImageId: id,
            });
            return;
        }
        push('PrepaidCardImageActivity', { prepaidCardImageId: id });
    };

    return (
        <Grid>
            {images.map((image) => (
                <Item key={image.id}
                    aria-label='prepaid-card-image'
                    data-name={image.title}
                    type='button'
                    onClick={() => handleClick(image.id)}
                    css={pressActionEffect}>
                    <Thumb src={image.imageUrl}
                        alt={image.title} />
                    <Text size='body-long' fontWeight='medium' align='center'>
                        {image.title}
                    </Text>
                </Item>
            ))}
        </Grid>
    );
}

const Grid = styled.div`
    display: grid;
    gap: var(--spacing-6) 0;
    grid-template-rows: auto;
    grid-template-columns: repeat(2, 1fr);
    padding: 0 var(--spacing-4);
    width: 100%;
`;

const Item = styled.button`
    background: transparent;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

const Thumb = styled(Image)`
    aspect-ratio: 3 / 2;
    border-radius: 4px;
    flex-shrink: 0;
    height: auto;
    object-fit: cover;
    width: 100%;
`;

export default ImageGrid;
